module.exports = fox._r("images/refresh_icon.png", __webpack_public_path__ + "images/refresh_icon.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/refresh_icon.png
// module id = 1096
// module chunks = 4